<p-menubar class="px-4 py-2 m-4 w-full max-w-full" [model]="mainMenuItems">
  <ng-template pTemplate="start">
    <img width="35px" height="35px" src="images/logo_small.png" alt="Datronix CRM Logo" class="logo-img">
  </ng-template>
  <ng-template pTemplate="end">
    <app-notification-bell></app-notification-bell>
    <button pButton type="button" [icon]="themeIcon" class="p-button-text" (click)="toggleTheme()"></button>
    <button pButton type="button" icon="pi pi-cog" class="p-button-text" (click)="goToSettings()" style="margin-right: 0.5rem;"></button>
    <p-menu #userMenu [popup]="true" [model]="userItems"></p-menu>
    <button pButton type="button" icon="pi pi-user" class="p-button-text" (click)="userMenu.toggle($event)"></button>
  </ng-template>
</p-menubar>
